// Load emojis from app config or use fallback
var emojis = (typeof window !== 'undefined' && window.appconfig?.emojis) || { set1: [] };

export { emojis };
